import { jsx as _jsx } from "react/jsx-runtime";
export const SvgText = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'M4 7V4h16v3m-8 13V4M9 20h6' }) }));
//# sourceMappingURL=text.js.map